import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChatMessagesComponent } from '@app/bot/chat-messages/chat-messages.component';
import { PlanIosListPage } from '@app/subscriptions/plan-ios-list/plan-ios-list.page';
import { ModalController } from '@ionic/angular';
import { AnalyticsEventEnum } from '@models/AnalyticsEventEnum';
import { AnalyticsService } from '@services/analytics/analytics.service';
import { InAppBrowserService } from '@services/api/in-app-browser/in-app-browser.service';
import { UserStoreService } from '@services/api/user-store/user-store.service';
import { UserService } from '@services/api/user/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-offline-tutorials',
  templateUrl: './offline-tutorials.page.html',
  styleUrls: ['./offline-tutorials.page.scss']
})
export class OfflineTutorialsPage implements OnInit {
  protected Swal = Swal;

  @ViewChild(ChatMessagesComponent, { static: true }) chat: ChatMessagesComponent;

  @Input()
  message: string;

  @Input()
  avatar: string = 'assets/imgs/metas/help-bot.png';

  @Input()
  title: string;

  @Input()
  youtubeURL: string | null;

  @Input()
  offerURL: string | null;

  @Input()
  offerIcon: string = 'assets/icon/giftbox.png';

  @Input()
  youtubeTextHTML: string | null;

  @Input()
  isDismissable: boolean = true;

  @Input()
  alertOfferDismiss: boolean = false;

  @Input()
  sendOpenBtnEvent: string | null;

  @Input()
  isIOS: boolean | null;

  @Input()
  withDiscount: boolean | null;

  constructor(
    private modalCtrl: ModalController,
    private inAppBrowserService: InAppBrowserService,
    private analyticsService: AnalyticsService,
    private userStoreService: UserStoreService,
    private userService: UserService
  ) {}

  ngOnInit() {
    if (!this.youtubeURL && !this.offerURL) throw new Error('Missing youtube/offer URL');
    this.chat.clearChatAndTypeBotMessage(this.message);
  }

  openTutorialOnYouTube() {
    if (!this.chat.hasFinishedTyping()) {
      this.chat.showCompleteText();
      return;
    }

    this.handleAnalyticsEvent();

    if (this.isIOS && this.offerURL) {
      return this.handleOpenIOSPurchase();
    }

    const link = this.youtubeURL || this.offerURL;
    this.inAppBrowserService.openLinkOnBrowser(link);

    this.modalCtrl.dismiss();
  }

  private async handleOpenIOSPurchase() {
    const userId =  this.userStoreService.user.objectId

    const modal = await this.modalCtrl.create({
      component: PlanIosListPage,
      componentProps: { userId }
    });

    await modal.present();
    await modal.onDidDismiss();

    const user = await this.userService.isUserExpired(userId);
    await this.userStoreService.saveUser(user);
    if (!this.userStoreService.userIsExpired() && !this.userStoreService.userIsFreemium()) {
      this.dismiss();
    }
  }

  private handleAnalyticsEvent() {
    if (this.sendOpenBtnEvent) {
      this.analyticsService.logEvent(this.sendOpenBtnEvent);
    } else {
      this.analyticsService.logEvent(AnalyticsEventEnum.BT_TUTORIAL_OPENED);
    }
  }

  dismiss() {
    if (this.alertOfferDismiss) {
      Swal.fire({
        heightAuto: false,
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        cancelButtonColor: '#d33',
        confirmButtonColor: '#43A047',
        cancelButtonText: 'Não quero turbinar meus estudos!',
        confirmButtonText: 'Quero turbinar meus estudos!',
        reverseButtons: true,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: false,
        title: 'Atenção',
        html: `<p class="sweet-alert-text">Ao fechar essa janela, a oferta não poderá ser acessada. <br/><br/> <b> Você quer mesmo deixar essa oportunidade escapar ? </b> </p>
              `
      }).then((result) => {
        if (result && result.dismiss && result.dismiss == Swal.DismissReason.cancel) {
          this.modalCtrl.dismiss();
        }
      });

      return;
    }

    return this.modalCtrl.dismiss();
  }
}
